import { render, staticRenderFns } from "./invoice-validation-form.vue?vue&type=template&id=3613c7bc&scoped=true&"
import script from "./invoice-validation-form.ts?vue&type=script&lang=ts&"
export * from "./invoice-validation-form.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-validation-form.scss?vue&type=style&index=0&id=3613c7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613c7bc",
  null
  
)

export default component.exports